module.exports = __webpack_public_path__ + "img/law4m-m@2.5fa68900.webp";